<template>
  <div style="width: 150px">
    <b-badge
      :style="{
        backgroundColor: getLightBackground(statusColor),
        color: statusName === 'N/A' ? '#000' : statusColor
      }"
      class="status-badge text-container"
    >
      {{ statusName }}
    </b-badge>
  </div>
</template>

<script>
import {
  BBadge,
} from 'bootstrap-vue'
import {
  mapGetters,
} from 'vuex'
import StatusMixin from '@core/mixins/status'

export default {
  name: 'OrderStatusBadge',
  components: {
    BBadge,
  },
  mixins: [StatusMixin],
  props: {
    statusKey: {
      type: String,
      default: 'N/A',
    },
  },
  computed: {
    ...mapGetters(['statusList']),
    statusColor() {
      const obj = this.statusList.find(n => n.key === this.statusKey)
      return obj ? obj.color : '#007bff'
    },
    statusName() {
      const obj = this.statusList.find(n => n.key === this.statusKey)
      return obj ? obj.name : 'N/A'
    },
  },
}
</script>

<style scoped>
@media (max-width: 767px) { /* Apply the style only for screens up to 767px wide (mobile) */
  .status-badge {
    display: inline-block;
    white-space: normal;
  }
}
.text-container {
  max-width: 100%; /* Set your desired maximum width */
  word-wrap: break-word; /* Break long words to the next line */
  white-space: normal; /* Allow whitespace to wrap */
}
</style>
